<script>
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "sveltestrap";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import SizeSelect from "../../../components/SizeSelect/SizeSelect.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import client from "../../../services/client";
	import PresetTaskTable from "./PresetTaskTable.svelte";
	import queryString from "query-string";
	import { listQueryParams } from "../../../services/helpers";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
	} from "../../../store/store";
	import { get } from "svelte/store";
	import { extractErrorMessage } from "src/utils/misc";

	let data = [];
	let taskCategories = [];
	let err;
	// let totalPages;
	const query = queryString.parse(window.location.search);

	if (query.status == "0") {
		query.status = true;
	} else if (query.status == "1") {
		query.status = false;
	}

	// console.log(query);

	async function fetchData() {
		try {
			if (parseInt(query.isActive) === 1) {
				query.isActive = true;
			} else if (parseInt(query.isActive) === 0) {
				query.isActive = false;
			}
			loading.set(true);
			const res = await client("/v1/presetTasks/search", {
				method: "POST",
				version: "Tasking",
				data: { ...listQueryParams(query), limit: get(sizeSelect) },
			});
			data = res.data.data;
			totalPages.set(res.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);
		}
	}

	async function fetchLookups() {
		try {
			const res = await client("/v1/tasks/lookups", {
				method: "GET",
				version: "Tasking",
			});
			taskCategories = res.data.taskCategories.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
		} catch (err) {
			console.log(err.response);
		}
	}

	const trigerSelectPresetTask = async (limit) => {
		try {
			loading.set(true);
			const res = await client("/v1/presetTasks/search", {
				method: "POST",
				version: "Tasking",
				data: { ...listQueryParams(query), limit: limit },
			});
			data = res.data.data;
			totalPages.set(res.data.totalPages);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err.response);
		}
	};

	async function handleStatusChange(presetTaskId, status) {
		try {
			const res = await client(
				`/v1/presetTasks/${presetTaskId}/isActive`,
				{
					method: "PUT",
					version: "Tasking",
					data: {
						isActive: status,
					},
				}
			);

			if (res.status === 204) {
				window.location.reload();
			}
		} catch (err) {
			console.log(err);
			extractErrorMessage(err);
		}
	}

	errorMessage.subscribe((value) => {
		err = value;
	});

	onMount(async () => {
		fetchData();
		fetchLookups();
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={$errorMessage} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Preset Task" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						description
						taskReferenceId
						taskCategoryId={taskCategories}
						isActive
					/>
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() => navigate("preset-task/create")}
							>Create Task</Button
						>
						<div class="my-2">
							<SizeSelect trigerSelect={trigerSelectPresetTask} />
						</div>
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<PresetTaskTable {data} {handleStatusChange} {taskCategories} />
	</Col>
</Row>
